import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { evaluateFormState } from '../ruleEngine';

export function useRuleEngine(control, fieldConfigs, contextValues = {}) {
  const allValues = useWatch({ control });

  const derivedState = useMemo(() => {
    const seeded = {};
    fieldConfigs.forEach(c => { seeded[c.fieldKey] = c.defaultValue ?? ''; });
    return evaluateFormState({ ...seeded, ...contextValues, ...allValues }, fieldConfigs);
  }, [allValues, fieldConfigs, contextValues]);

  return derivedState;
}
